var map = {
	"./uploaddemo-1-a.png": "1ecd",
	"./uploaddemo-2-a.png": "13be",
	"./uploaddemo-3-a.png": "4e09",
	"./uploaddemo-4-a.png": "c790"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d3ec";